import {
  JourneyServicesReply,
  ServiceItem,
  ServicesCatalogueReplyData,
} from '@dapi/sdk';
import {
  combineServicesCatalogueItems,
  createTraveler,
  createUnitPrice,
  generateId,
  MockServicesCatalogueItem,
  PriceRepository,
} from '@dapi/sdk/spec';

export const servicesItems: MockServicesCatalogueItem[] = combineServicesCatalogueItems([
  {
    descriptions: [
      {
        content: 'PDBG',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-0',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK', 'JOURNEY-TRAVELER-1-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
        }
      })]
    },
    tags: ['OTH']
  },
  {
    descriptions: [
      {
        content: 'PDBG',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK', 'CHECK-IN-FLIGHT-1-MOCK'],
    id: 'SERVICE-1',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK', 'JOURNEY-TRAVELER-1-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
        }
      })]
    },
    tags: ['OTH']
  },
  {
    descriptions: [
      {
        content: 'PDBG',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-1-MOCK'],
    id: 'SERVICE-2',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK', 'JOURNEY-TRAVELER-1-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
        }
      })]
    },
    tags: ['OTH']
  }
]).items;

export const serviceCatalog: ServicesCatalogueReplyData[] = [
  {
    services: [
      ...servicesItems
    ]
  }
];
export const servicesPDBGPDSTBIKEItems: MockServicesCatalogueItem[] = combineServicesCatalogueItems([
  {
    descriptions: [
      {
        content: 'PDBG',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-0',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK', 'JOURNEY-TRAVELER-1-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
        }
      })]
    },
    tags: ['OTH']
  },
  {
    descriptions: [
      {
        content: 'XBAG',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-0',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
        }
      })]
    },
    tags: ['OTH']
  },
  {
    descriptions: [
      {
        content: 'PDST',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-1',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK', 'JOURNEY-TRAVELER-1-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
        }
      })]
    },
    tags: ['OTH']
  },
  {
    descriptions: [
      {
        content: 'PDST',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-1-MOCK'],
    id: 'SERVICE-1',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK', 'JOURNEY-TRAVELER-1-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
        }
      })]
    },
    tags: ['OTH']
  },
  {
    descriptions: [
      {
        content: 'BIKE',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-2',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK', 'JOURNEY-TRAVELER-1-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
        }
      })]
    },
    tags: ['OTH']
  }
]).items;

export const servicePDBGPDSTBIKECatalog: ServicesCatalogueReplyData[] = [
  {
    services: [
      ...servicesPDBGPDSTBIKEItems
    ]
  }
];

export const servicesResponsePDST: MockServicesCatalogueItem[] = combineServicesCatalogueItems([
  {
    descriptions: [
      {
        content: 'PDST',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-1',
    quantity: 1,
    statusCode: 'MCF',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
  },
  {
    descriptions: [
      {
        content: 'PDST',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-1-MOCK'],
    id: 'SERVICE-1',
    quantity: 1,
    statusCode: 'MCF',
    travelerIds: ['JOURNEY-TRAVELER-1-MOCK']
  },
  {
    descriptions: [
      {
        content: 'XBAG',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-0',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
        }
      })]
    },
    tags: ['OTH']
  }
]).items;

export const servicesResponsebag: MockServicesCatalogueItem[] = combineServicesCatalogueItems([

  {
    descriptions: [
      {
        content: 'XBAG',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-0',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
        }
      })]
    },
    tags: ['OTH']
  }
]).items;

export const servicePDBGPDSTCatalog: ServicesCatalogueReplyData[] = [
  {
    services: [
      ...servicesResponsePDST
    ]
  }
];

export const servicesResponseBIKE: MockServicesCatalogueItem[] = combineServicesCatalogueItems([
  {
    descriptions: [
      {
        content: 'BIKE',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-2',
    quantity: 1,
    statusCode: 'MCF',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
  }]).items;

export const throughPricingServicesItems: MockServicesCatalogueItem[] = combineServicesCatalogueItems([
  {
    descriptions: [
      {
        content: 'PBRD',
        type: 'shortText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-0',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK', 'JOURNEY-TRAVELER-1-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK'],
          flightIds: ['CHECK-IN-FLIGHT-0-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK'],
          flightIds: ['CHECK-IN-FLIGHT-0-MOCK']
        }
      })]
    }
  },
  {
    descriptions: [
      {
        content: 'PBRD',
        type: 'shortText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK', 'CHECK-IN-FLIGHT-1-MOCK'],
    id: 'SERVICE-1',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK', 'JOURNEY-TRAVELER-1-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK'],
          flightIds: ['CHECK-IN-FLIGHT-1-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK'],
          flightIds: ['CHECK-IN-FLIGHT-1-MOCK']
        }
      })]
    }
  },
  {
    descriptions: [
      {
        content: 'PBRD',
        type: 'shortText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-1-MOCK'],
    id: 'SERVICE-2',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK', 'JOURNEY-TRAVELER-1-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK'],
          flightIds: ['CHECK-IN-FLIGHT-0-MOCK', 'CHECK-IN-FLIGHT-1-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK'],
          flightIds: ['CHECK-IN-FLIGHT-0-MOCK', 'CHECK-IN-FLIGHT-1-MOCK']
        }
      })]
    }
  }
]).items;

export const throughPricingServiceCatalog: ServicesCatalogueReplyData[] = [
  {
    services: [
      ...throughPricingServicesItems
    ]
  }
];

const traveler1 = createTraveler({
  template: {
    passengerTypeCode: 'ADT',
    names: [{
      firstName: 'John',
      lastName: 'Doe',
      title: 'MR'
    }],
    id: 'JOURNEY-TRAVELER-0-MOCK'
  }
});

export const servicesResponseBoarding: ServiceItem[] = [
  {
    descriptions: [
      {
        content: 'PBRD',
        type: 'shortText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: generateId('JourneyUnpaidService', '0'),
    quantity: 1,
    statusCode: 'MCF',
    travelerId: 'JOURNEY-TRAVELER-0-MOCK',
    traveler: traveler1
  },
  {
    descriptions: [
      {
        content: 'PBRD',
        type: 'shortText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-1-MOCK'],
    id: generateId('JourneyUnpaidService', '1'),
    travelerId: 'JOURNEY-TRAVELER-0-MOCK',
    quantity: 1,
    statusCode: 'MCF',
    traveler: traveler1
  }
];

export const servicesResponseBoardings: JourneyServicesReply = {
  data: servicesResponseBoarding
};

export const servicesResponseBoarding1: ServiceItem[] = [
  {
    descriptions: [
      {
        content: 'PBRD',
        type: 'shortText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: generateId('JourneyUnpaidService', '0'),
    quantity: 1,
    statusCode: 'MCF',
    travelerId: 'JOURNEY-TRAVELER-0-MOCK',
    traveler: traveler1
  },
  {
    descriptions: [
      {
        content: 'PBRD',
        type: 'shortText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: generateId('JourneyUnpaidService', '1'),
    travelerId: 'JOURNEY-TRAVELER-1-MOCK',
    quantity: 1,
    statusCode: 'MCF',
    traveler: traveler1
  }
];

export const servicesResponseBoardings1: JourneyServicesReply = {
  data: servicesResponseBoarding1
};

export const ServicesItems1: MockServicesCatalogueItem[] = combineServicesCatalogueItems([
  {
    descriptions: [
      {
        content: 'PBRD',
        type: 'shortText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-0',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK', 'JOURNEY-TRAVELER-1-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK'],
          flightIds: ['CHECK-IN-FLIGHT-0-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK'],
          flightIds: ['CHECK-IN-FLIGHT-0-MOCK']
        }
      })]
    }
  },
  {
    descriptions: [
      {
        content: 'PBRD',
        type: 'shortText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-1',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK', 'JOURNEY-TRAVELER-1-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK'],
          flightIds: ['CHECK-IN-FLIGHT-0-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK'],
          flightIds: ['CHECK-IN-FLIGHT-0-MOCK']
        }
      })]
    }
  },
  {
    descriptions: [
      {
        content: 'PBRD',
        type: 'shortText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-2',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK'],
          flightIds: ['CHECK-IN-FLIGHT-0-MOCK']
        }
      }),
      createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-1-MOCK'],
          flightIds: ['CHECK-IN-FLIGHT-0-MOCK']
        }
      })]
    }
  },
  {
    descriptions: [
      {
        content: 'BIKE',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-3',
    quantity: 1,
    statusCode: 'MCF',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
  },
  {
    descriptions: [
      {
        content: 'XBAG',
        type: 'shortText'
      },
      {
        content: 'B1',
        type: 'longText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: 'SERVICE-4',
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK'],
    prices: {
      totalPrices: [PriceRepository.DEFAULT, PriceRepository.DEFAULT],
      unitPrices: [createUnitPrice({
        template: {
          travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
        }
      })]
    },
    tags: ['OTH']
  }
]).items;

export const ServiceCatalog: ServicesCatalogueReplyData[] = [
  {
    services: [
      ...ServicesItems1
    ]
  }
];

export const servicesResponseBoardingforOnepax: ServiceItem[] = [
  {
    descriptions: [
      {
        content: 'PBRD',
        type: 'shortText'
      }],
    flightIds: ['CHECK-IN-FLIGHT-0-MOCK'],
    id: generateId('JourneyUnpaidService', '0'),
    quantity: 1,
    statusCode: 'MCF',
    travelerId: 'JOURNEY-TRAVELER-0-MOCK',
    traveler: traveler1
  }
];

export const servicesResponseBoardingsOnepax: JourneyServicesReply = {
  data: servicesResponseBoardingforOnepax
};
